var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBagStorage = function SvgBagStorage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 20.204 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m7.102 12.6 2 2 4.5-4.5m.5-5.5a4 4 0 0 0-8 0M3.6 20.6h13.004a3 3 0 0 0 2.994-3.187l-.625-10A3 3 0 0 0 15.979 4.6H4.225A3 3 0 0 0 1.23 7.413l-.625 10A3 3 0 0 0 3.6 20.6"
  })));
};
export default SvgBagStorage;